import { toErrorLogContext } from "@/shared/http";
import { createLogger } from "@/shared/logging";
import { PollingController, type PollingSnapshot } from "@/shared/polling/PollingController";
import { getServerInfo, type ServerInfo } from "./serverInfoApi";

export type ServerInfoSnapshot = PollingSnapshot<ServerInfo>;
const logger = createLogger("app/serverInfo");

// 로그인 세션이 폴링을 소유하므로 라우트마다 요청과 타이머를 만들지 않는다.
export const serverInfoController = new PollingController<ServerInfo>({
  load: getServerInfo,
  intervalMs: 5 * 60_000,
  onLoadError: (error) => logger.warn("Failed to load server info.", toErrorLogContext(error)),
});
